import sampleBed from '../../images/amazonProducts/sampleBed.jpg'
import sampleWheel from '../../images/amazonProducts/sampleWheel.jpg'
import sampleBackpack from '../../images/amazonProducts/sampleBackpack.jpg'
import sampleFlight from '../../images/amazonProducts/sampleFlight.jpg'
import sampleShampoo from '../../images/amazonProducts/sampleShampoo.jpg'
import sampleTreats from '../../images/amazonProducts/sampleTreats.jpg'
import sampleMist from '../../images/amazonProducts/sampleMist.jpg'

// const categories = {
//   1: "Toy",
//   2: "Food/Treat",
//   3: "",
//   4: "",
//   5: "",
//   6: "",
// };

// {
// 	title: "string",
// 	amazonAffiliateLink: string | null,
// 	amazonLink: string | null,
// 	photo: string | null,
// 	category: string,
// 	likes: number
// },

export const PicksData = [
  {
    title: "Chuckit Fetch Wheel",
    amazonAffiliateLink: "https://amzn.to/3Tz6MyO",
    amazonLink: null,
    photo: sampleWheel,
    category: "Toy",
    likes: 0,
  },
  {
    title: "Calming Dog Bed",
    amazonAffiliateLink: "https://amzn.to/3VkwJ6C",
    amazonLink: null,
    photo: sampleBed,
    category: "Bed",
    likes: 0,
  },
  {
    title: "Chuckit Whistle Flight",
    amazonAffiliateLink: "https://amzn.to/3vaEiSG",
    amazonLink: null,
    photo: sampleFlight,
    category: "Toy",
    likes: 0,
  },
  {
    title: "The Honest Kitchen Goat's Milk N' Cookies Slow Baked Dog Treats	 Variety Pack",
    amazonAffiliateLink: "https://amzn.to/3Pnll6d",
    amazonLink: null,
    photo: sampleTreats,
    category: "Treat",
    likes: 0,
  },
  {
    title: "RELIQ Natural Rosemary Shampoo",
    amazonAffiliateLink: "https://amzn.to/3TzAxQ4",
    amazonLink: null,
    photo: sampleShampoo,
    category: "Grooming",
    likes: 0,
  },
  {
    title: "RELIQ Pomegranate Botanical Mist",
    amazonAffiliateLink: "https://amzn.to/48YiyHr",
    amazonLink: null,
    photo: sampleMist,
    category: "Grooming",
    likes: 0,
  },
  {
    title: "K9 Sport Knavigate Backpack",
    amazonAffiliateLink: "https://amzn.to/49R4zoc",
    amazonLink: null,
    photo: sampleBackpack,
    category: "Apperal",
    likes: 0,
  },
];
